import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProductService } from '../../services/ProductService';
import { Router } from '@angular/router';
import { MdSnackBar, MdDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import 'rxjs/Rx';
import { AdalService } from '../../shared/adal.service';
import { AppLoaderService } from '../../../services/app-loader/app-loader.service';
@Component({
    selector: 'my-page-layout-add-Product',
    styles: [],
    template: require('./addproduct.component.html')
})

export class PageLayoutProductaddComponent {
    private sub: Subscription;
    ProductData;
    errorMessage: string;
    submitted = false;
    validationForm: FormGroup;
    ProductId: number;

    constructor(public dialog: MdDialog,
        private router: Router,        
        private formBuilder: FormBuilder,
        public snackBar: MdSnackBar,
        private adalService: AdalService,
        private appLoaderService: AppLoaderService,
        private productService: ProductService) {

        //Check Authentication        
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(['login']);
        }
        this.getProducts();
    }

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {        
        this.ProductId = 0;
        this.validationForm = this.formBuilder.group({
            ProductName: ['', Validators.required],
            Code: ['', Validators.required],
            SubType: ['', Validators.required]
        });
    }

    getProducts() {
        this.productService.getProduct().subscribe(
            data => {
                if (!data.IsError  && data.DataObject != null) {
                    this.ProductData = data.DataObject;
                }
            },
            error => {
                this.errorMessage = error;
            });
    }

    onSubmit(): void {
        this.submitted = true;        
        if (this.validationForm.invalid) {
            return;
        }
        this.SaveProductDetail();
    }

    oneditcancel(): void {
        this.errorMessage = "";
        this.ProductId = 0;
        this.submitted = false;
        this.validationForm.patchValue({
            ProductName: '',
            Code: '',
            SubType: ''
        });
    }

    EditProductDetail(row) {
        this.ProductId = row.ProductId;
        this.validationForm.patchValue({
            ProductName: row.ProductName,
            Code: row.Code,
            SubType: row.SubType
        });
    }

    SaveProductDetail(): void {
        this.errorMessage = "";
        if (this.ProductId == 0) {
            this.appLoaderService.open();
            let model = {
                ProductId: 0,
                ProductName: this.validationForm.value.ProductName,
                Code: this.validationForm.value.Code,
                SubType: this.validationForm.value.SubType,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid'))
            };
            this.productService.addProduct(model).subscribe(
                response => {
                    if (response.IsError || response.DataObject == null) {
                        this.errorMessage = "Product Code is already Exists..!";
                        this.appLoaderService.close();
                    }
                    else {
                        this.submitted = false;
                        this.validationForm.patchValue({
                            ProductName: '',
                            Code: '',
                            SubType: ''
                        });

                        this.snackBar.open("Product Created Successfully", "", {
                            duration: 2000,
                        });
                        this.appLoaderService.close();
                        this.productService.notifyOther({ option: 'onSave', value: 'Product Created Successfully' });
                        this.getProducts();
                    }
                },
                (_error: any) => {this.appLoaderService.close()});
        }
        else {
            this.appLoaderService.open();
            let model = {
                ProductId: this.ProductId,
                ProductName: this.validationForm.value.ProductName,
                Code: this.validationForm.value.Code,
                SubType: this.validationForm.value.SubType,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid'))
            };
            
            this.productService.updateProduct(model).subscribe(
                response => {
                    if (response.IsError || response.DataObject == null) {
                        this.errorMessage = "Product Code is already Exists..!";
                        this.appLoaderService.close();
                    }
                    else {
                        this.submitted = false;
                        this.validationForm.patchValue({
                            ProductName: '',
                            Code: '',
                            SubType: ''
                        });
                        this.snackBar.open("Product Update Successfully", "", {
                            duration: 2000,
                        });
                        this.appLoaderService.close();
                        this.productService.notifyOther({ option: 'onSave', value: 'Product Updated Successfully' });
                        this.getProducts();
                    }
                },
                (_error: any) => {this.appLoaderService.close()});
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/add-product/addproduct.component.ts